import { useState, useEffect } from "react";

import BusinessCard from "../components/BusinessCard/BusinessCard";
import LoadScreen from "../components/LoadScreen/LoadScreen";

import styles from "./home.module.scss";
import JoshIMG from "../assets/josh.jpeg";

const Home = () => {
    const [isLoadScreen, setIsLoadScreen] = useState(true);
    const personalData = {
        name: "Josh Tucker",
        role: "Director of Operations",
        phone: "6478255674",
        email: "josh@generationmarketing.ca",
        img: JoshIMG,
        linkedInLink: "https://www.linkedin.com/in/joshctucker/",
        routeToVCF: "/Josh_Tucker.vcf",
    };

    useEffect(() => {
        setTimeout(() => {
            setIsLoadScreen(() => false);
        }, 2500);
    }, []);

    return (
        <div className={styles.home_page}>
            <BusinessCard data={personalData} />
            {!!isLoadScreen && <LoadScreen />}
        </div>
    );
};

export default Home;
